module.exports = __webpack_public_path__ + "static/media/agenda-02.6876be9d.jpg";